import {
  // Lançamentos Banco
  BUSCAR_LANCAMENTOS_BANCO_PENDING,
  BUSCAR_LANCAMENTOS_BANCO_SUCCESS,
  BUSCAR_LANCAMENTOS_BANCO_FAILURE,

  // Contas a Pagar
  BUSCAR_CONTAS_PAGAR_PENDING,
  BUSCAR_CONTAS_PAGAR_SUCCESS,
  BUSCAR_CONTAS_PAGAR_FAILURE,

  // Contas a Receber
  BUSCAR_CONTAS_RECEBER_PENDING,
  BUSCAR_CONTAS_RECEBER_SUCCESS,
  BUSCAR_CONTAS_RECEBER_FAILURE
} from './actionTypes';

const initialState = {
  lancamentosBanco: {
    loading: false,
    data: null,
    error: null,
    filter: {}
  },
  contasPagar: {
    loading: false,
    data: null,
    error: null,
    filter: {}
  },
  contasReceber: {
    loading: false,
    data: null,
    error: null,
    filter: {}
  }
};

export default function buscarLancamentosReducer(state = initialState, action) {
  switch (action.type) {
    // === LANÇAMENTOS BANCO ===
    case BUSCAR_LANCAMENTOS_BANCO_PENDING:
      return {
        ...state,
        lancamentosBanco: {
          ...state.lancamentosBanco,
          loading: true,
          error: null
        }
      };

    case BUSCAR_LANCAMENTOS_BANCO_SUCCESS:
      return {
        ...state,
        lancamentosBanco: {
          ...state.lancamentosBanco,
          loading: false,
          data: action.data,
          error: null,
          filter: action.filter || {}
        }
      };

    case BUSCAR_LANCAMENTOS_BANCO_FAILURE:
      return {
        ...state,
        lancamentosBanco: {
          ...state.lancamentosBanco,
          loading: false,
          error: action.error
        }
      };

    // === CONTAS A PAGAR ===
    case BUSCAR_CONTAS_PAGAR_PENDING:
      return {
        ...state,
        contasPagar: {
          ...state.contasPagar,
          loading: true,
          error: null
        }
      };

    case BUSCAR_CONTAS_PAGAR_SUCCESS:
      return {
        ...state,
        contasPagar: {
          ...state.contasPagar,
          loading: false,
          data: action.data,
          error: null,
          filter: action.filter || {}
        }
      };

    case BUSCAR_CONTAS_PAGAR_FAILURE:
      return {
        ...state,
        contasPagar: {
          ...state.contasPagar,
          loading: false,
          error: action.error
        }
      };

    // === CONTAS A RECEBER ===
    case BUSCAR_CONTAS_RECEBER_PENDING:
      return {
        ...state,
        contasReceber: {
          ...state.contasReceber,
          loading: true,
          error: null
        }
      };

    case BUSCAR_CONTAS_RECEBER_SUCCESS:
      return {
        ...state,
        contasReceber: {
          ...state.contasReceber,
          loading: false,
          data: action.data,
          error: null,
          filter: action.filter || {}
        }
      };

    case BUSCAR_CONTAS_RECEBER_FAILURE:
      return {
        ...state,
        contasReceber: {
          ...state.contasReceber,
          loading: false,
          error: action.error
        }
      };

    default:
      return state;
  }
}